import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import Logo from "../../assets/images/Logo-Icon-Regular.svg";

import { Paper, Typography } from "@mui/material";
import SignInComponent from "../../components/auth/SignIn";

const Brand = styled.img`
  margin-top: 1rem;
  width: 64px;
  height: 64px;
  margin-bottom: 32px;
`;

const Wrapper = styled(Paper)`
  padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)};
  }
`;

function SignIn() {
  return (
    <React.Fragment>
      <Brand src={Logo} />
      <Wrapper>
        <Helmet title="Sign In" />

        <Typography component="h1" variant="h4" align="center" gutterBottom>
          Welcome back!
        </Typography>
        <Typography component="h2" variant="body1" align="center" mb={5}>
          Sign in to your account to continue
        </Typography>

        <SignInComponent />
      </Wrapper>
    </React.Fragment>
  );
}

export default SignIn;
